module.exports = __webpack_public_path__ + "img/ic_log_select.b6c9f548.png";